module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro4.74bf347b.mp3";